var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.348 7.5C13.326 7.5 12.4435 8.0985 12 8.9715C11.5565 8.0985 10.674 7.5 9.652 7.5C8.187 7.5 7 8.7285 7 10.2405C7 11.7525 7.9085 13.1385 9.0825 14.277C10.2565 15.4155 12 16.5 12 16.5C12 16.5 13.687 15.4335 14.9175 14.277C16.23 13.044 17 11.757 17 10.2405C17 8.724 15.813 7.5 14.348 7.5Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddwhite);
export default __webpack_public_path__ + "static/media/addwhite.4c973bebe337d413d31738017ce63994.svg";
export { ForwardRef as ReactComponent };